export enum ProcessStatus {
  NotProcessed = 'NotProcessed',
  PendingDelete = 'PendingDelete',
  PendingProcess = 'PendingProcess',
  PendingUnprocess = 'PendingUnprocess',
  Processed = 'Processed',
}
